import { FintrafficLogo } from './FintrafficLogo';
export default FintrafficLogo;
